import { BrowserRouter as Router, Routes, Route, useParams, useLocation } from "react-router-dom";
import Login from "./pages/Login";
import ProfileSetup from "./pages/ProfileSetup";
import Dashboard from "./pages/Dashboard";
import CreateAccount from "./pages/CreateAccount";
import ForgotPassword from "./pages/ForgotPassword";
import ConfirmReservation from "./pages/ConfirmReservation";
import { UserContext } from './context/UserContext';
import { useContext, useEffect } from 'react';
import { useCookies } from "react-cookie";
import TostMessageComponent from "./TostMessageComponent/TostMessageComponent";
import ScrollToTop from "./ScrollToTop";

export default function App() {

  const {setUserProfile, logOutFunction, reloadUser} = useContext(UserContext);
  const [cookies, setCookie, removeCookie] = useCookies();
  const location = useLocation();
  const {token} = useParams();

  useEffect(() => {
    // console.log(location, location.pathname.split("/").filter(Boolean)[0]);
    console.log(cookies?.userProfile);
    if (location.pathname != "/") {
      if (cookies?.userProfile != null) {
        setUserProfile(cookies?.userProfile);
      } else {
        logOutFunction();
      }
    }
  }, [])

  return (
    <div>
      <ScrollToTop />
      <TostMessageComponent />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/create-account" element={<CreateAccount />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/profile-setup" element={<ProfileSetup />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
      </Routes>
    </div>
  );
}